import styled, { css } from 'styled-components';
const Primary = css`
  background-color: rgba(0, 0, 0, 0.5);
  color: ${({
  theme
}) => theme.base.white};
`;
const Secondary = css`
  background: ${({
  theme
}) => theme.base.white};
  color: ${({
  theme
}) => theme.primary.main};
`;
const Tag = styled.div`
  font-family: ${({
  theme
}) => theme.fonts.primary};
  padding: 8px;
  font-size: 10px;
  display: inline-block;
  ${props => props.type === 'primary' && Primary}
  ${props => props.type === 'secondary' && Secondary}
`;
export default Tag;